/* eslint-disable react-hooks/exhaustive-deps */
import React, { MouseEvent } from "react"

import { useLayerPopupContext } from "@shared/contexts"
import {
  ChatSound,
  DisplayRatio,
  getChatSound,
  setChatSound,
  setDisplay,
} from "@shared/modules"

function Setting() {
  const { video, close } = useLayerPopupContext()

  const displayRatioOptions = [
    { key: "원본비율", value: "originalRatio" },
    { key: "화면비율", value: "displayRatio" },
  ]

  const SoundAlarmOptions = [
    { key: "끄기", value: "OFF" },
    { key: "켜기", value: "ON" },
  ]

  const handleSoundOption = (event: MouseEvent, chatSound: ChatSound) => {
    event.preventDefault()
    setChatSound(chatSound)
    close()
  }

  return (
    <React.Fragment>
      <article
        className="popup"
        style={{ width: "620px", margin: "-100px 0 0 -400px" }}
      >
        <div className="titB">
          <h1>환경설정</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <dl>
            <dt>화면비율</dt>
            {displayRatioOptions.map((displayOption) => {
              return (
                <dd key={displayOption.key}>
                  <span className="radioB">
                    <a
                      href="#!"
                      className={displayOption.value === video.size ? "on" : ""}
                      onClick={(e: MouseEvent) => {
                        e.preventDefault()
                        video.handleVideo({
                          size: displayOption.value as DisplayRatio,
                        })
                        setDisplay(displayOption.value as DisplayRatio)
                        close()
                      }}
                    >
                      <i>-</i>
                      {displayOption.key}
                    </a>
                  </span>
                </dd>
              )
            })}
          </dl>
          <dl className="ty01">
            <dt>채팅효과음</dt>
            {SoundAlarmOptions.map((soundOption) => {
              return (
                <dd key={soundOption.key}>
                  <span className="radioB">
                    <a
                      href="#!"
                      className={
                        soundOption.value === getChatSound() ? "on" : ""
                      }
                      onClick={(e: MouseEvent) => {
                        handleSoundOption(e, soundOption.value as ChatSound)
                      }}
                    >
                      <i>-</i>
                      {soundOption.key}
                    </a>
                  </span>
                </dd>
              )
            })}
          </dl>
        </div>
      </article>
    </React.Fragment>
  )
}

export default Setting
